(function () {
  'use strict';

  var page = document.querySelector('[data-supabase-wishlist-page]');

  if (!page) return;

  var host = document.getElementById('WishlistSupabase');

  if (!host) {
    console.error('[Wishlist Page] Supabase host not found.');
    return;
  }

  var supabaseUrl = host.dataset.supabaseUrl;
  var supabaseKey = host.dataset.supabaseAnonKey;
  var customerId = host.dataset.customerId;

  var loading = page.querySelector('[data-wishlist-loading]');
  var empty = page.querySelector('[data-wishlist-empty]');
  var grid = page.querySelector('[data-wishlist-grid]');
  var errorBox = page.querySelector('[data-wishlist-error]');

  if (!customerId) return;

  function headers(extra) {
    return Object.assign(
      {
        apikey: supabaseKey,
        Authorization: 'Bearer ' + supabaseKey,
        'x-customer-id': customerId
      },
      extra || {}
    );
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'INR'
      }).format(Number(cents) / 100);
    } catch (error) {
      return 'Rs. ' + (Number(cents) / 100).toFixed(2);
    }
  }

  async function getWishlistRows() {
    var url =
      supabaseUrl +
      '/rest/v1/wishlists' +
      '?select=id,customer_id,product_handle,variant_id,created_at' +
      '&customer_id=eq.' +
      encodeURIComponent(customerId) +
      '&order=created_at.desc';

    var response = await fetch(url, {
      method: 'GET',
      headers: headers()
    });

    if (!response.ok) {
      throw new Error(
        'Wishlist request failed: ' +
          response.status +
          ' ' +
          (await response.text())
      );
    }

    return response.json();
  }

  async function getProduct(handle) {
    var response = await fetch(
      '/products/' + encodeURIComponent(handle) + '.js',
      {
        credentials: 'same-origin'
      }
    );

    if (!response.ok) {
      throw new Error(
        'Product request failed for ' + handle
      );
    }

    return response.json();
  }

  function findVariant(product, variantId) {
    return product.variants.find(function (variant) {
      return String(variant.id) === String(variantId);
    });
  }

  function productImage(product, variant) {
    if (variant && variant.featured_image) {
      if (typeof variant.featured_image === 'string') {
        return variant.featured_image;
      }

      if (variant.featured_image.src) {
        return variant.featured_image.src;
      }
    }

    if (product.featured_image) {
      return product.featured_image;
    }

    if (product.images && product.images.length) {
      return product.images[0];
    }

    return '';
  }

  function createCard(item) {
    var row = item.row;
    var product = item.product;
    var variant = item.variant;

    var image = productImage(product, variant);
    var productUrl =
      '/products/' +
      encodeURIComponent(product.handle) +
      '?variant=' +
      encodeURIComponent(variant.id);

    var card = document.createElement('article');

    card.className = 'supabase-wishlist-card';
    card.dataset.wishlistRowId = row.id;
    card.dataset.variantId = String(variant.id);

    card.innerHTML =
      '<div class="supabase-wishlist-card__media">' +
        '<a href="' + escapeHtml(productUrl) + '">' +
          (
            image
              ? '<img class="supabase-wishlist-card__image" src="' +
                escapeHtml(image) +
                '" alt="' +
                escapeHtml(product.title) +
                '" loading="lazy" width="600" height="800">'
              : ''
          ) +
        '</a>' +

        '<button type="button" class="supabase-wishlist-card__remove" data-wishlist-remove aria-label="Remove ' +
          escapeHtml(product.title) +
          ' from wishlist">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true">' +
            '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3 9.24 3 10.91 3.81 12 5.08 13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5 22 12.28 18.6 15.36 13.45 19.99 12 21.35z" fill="currentColor"></path>' +
          '</svg>' +
        '</button>' +
      '</div>' +

      '<div class="supabase-wishlist-card__content">' +
        '<a class="supabase-wishlist-card__title" href="' +
          escapeHtml(productUrl) +
          '">' +
          escapeHtml(product.title) +
        '</a>' +

        '<p class="supabase-wishlist-card__variant">' +
          escapeHtml(variant.title) +
        '</p>' +

        '<p class="supabase-wishlist-card__price">' +
          escapeHtml(
            formatMoney(
              variant.price,
              window.Shopify && window.Shopify.currency
                ? window.Shopify.currency.active
                : 'INR'
            )
          ) +
        '</p>' +

        '<button type="button" class="supabase-wishlist-card__cart" data-wishlist-add-cart ' +
          (variant.available ? '' : 'disabled') +
        '>' +
          (variant.available ? 'Add to Cart' : 'Sold Out') +
        '</button>' +
      '</div>';

    return card;
  }

  async function removeRow(rowId) {
    var url =
      supabaseUrl +
      '/rest/v1/wishlists?id=eq.' +
      encodeURIComponent(rowId);

    var response = await fetch(url, {
      method: 'DELETE',
      headers: headers({
        Prefer: 'return=minimal'
      })
    });

    if (!response.ok) {
      throw new Error(
        'Remove failed: ' +
          response.status +
          ' ' +
          (await response.text())
      );
    }
  }

  async function addVariantToCart(variantId) {
    var response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    });

    if (!response.ok) {
      throw new Error(
        'Cart request failed: ' +
          response.status +
          ' ' +
          (await response.text())
      );
    }

    return response.json();
  }

  function updateEmptyState() {
    var cards = grid.querySelectorAll(
      '.supabase-wishlist-card'
    );

    if (cards.length === 0) {
      grid.hidden = true;
      empty.hidden = false;
    }
  }

  page.addEventListener('click', async function (event) {
    var removeButton = event.target.closest(
      '[data-wishlist-remove]'
    );

    if (removeButton) {
      var removeCard = removeButton.closest(
        '.supabase-wishlist-card'
      );

      if (!removeCard) return;

      removeButton.disabled = true;

      try {
        await removeRow(
          removeCard.dataset.wishlistRowId
        );

        removeCard.remove();

        document.dispatchEvent(
          new CustomEvent('wishlist:changed')
        );

        updateEmptyState();
      } catch (error) {
        console.error('[Wishlist Page]', error);
        removeButton.disabled = false;
      }

      return;
    }

    var cartButton = event.target.closest(
      '[data-wishlist-add-cart]'
    );

    if (cartButton) {
      var cartCard = cartButton.closest(
        '.supabase-wishlist-card'
      );

      if (!cartCard) return;

      var originalText = cartButton.textContent;

      cartButton.disabled = true;
      cartButton.textContent = 'Adding...';

      try {
        await addVariantToCart(
          cartCard.dataset.variantId
        );

        cartButton.textContent = 'Added ✓';

        document.dispatchEvent(
          new CustomEvent('cart:refresh')
        );

        setTimeout(function () {
          cartButton.disabled = false;
          cartButton.textContent = originalText;
        }, 1500);
      } catch (error) {
        console.error('[Wishlist Page]', error);

        cartButton.disabled = false;
        cartButton.textContent = 'Try Again';
      }
    }
  });

  async function init() {
    try {
      loading.hidden = false;
      empty.hidden = true;
      grid.hidden = true;
      errorBox.hidden = true;

      var rows = await getWishlistRows();

      if (!rows.length) {
        loading.hidden = true;
        empty.hidden = false;
        return;
      }

      var results = await Promise.all(
        rows.map(async function (row) {
          try {
            var product = await getProduct(
              row.product_handle
            );

            var variant = findVariant(
              product,
              row.variant_id
            );

            if (!variant) {
              console.warn(
                '[Wishlist Page] Variant not found:',
                row.variant_id,
                row.product_handle
              );

              return null;
            }

            return {
              row: row,
              product: product,
              variant: variant
            };
          } catch (error) {
            console.error(
              '[Wishlist Page] Product load failed:',
              row.product_handle,
              error
            );

            return null;
          }
        })
      );

      var validItems = results.filter(Boolean);

      loading.hidden = true;

      if (!validItems.length) {
        empty.hidden = false;
        return;
      }

      grid.innerHTML = '';

      validItems.forEach(function (item) {
        grid.appendChild(createCard(item));
      });

      grid.hidden = false;
    } catch (error) {
      console.error('[Wishlist Page]', error);

      loading.hidden = true;
      errorBox.hidden = false;
    }
  }

  init();
})();